import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { GrupoClassificacao } from '../grupo-classificacao';
import { GrupoClassificacaoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class GrupoClassificacaoCrudHttpService implements Crud<GrupoClassificacao> {
    resource = 'grupoclassificacao';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todos os grupos de classificações cadastrados */
    search(): Observable<GrupoClassificacao[]> {
        return this.crudService.search<GrupoClassificacao>(this.resource);
    }

    /** Pesquisa todos os grupos de classificações cadastrados */
    searchWithFilter(filter: GrupoClassificacaoFilter): Observable<GrupoClassificacao[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.crudService.search<GrupoClassificacao>(this.resource, {params});
    }

    /** Procura um único grupo de classificação através do seu ID */
    find(id: number): Observable<GrupoClassificacao> {
        return this.crudService.find<GrupoClassificacao>(this.resource, id);
    }

    /** Carrega um único grupo de classificação através do seu ID */
    load(id: number): Observable<GrupoClassificacao> {
        return this.crudService.load<GrupoClassificacao>(this.resource, id);
    }

    /** Insere um novo grupo de classificação */
    insert(entity: GrupoClassificacao): Observable<GrupoClassificacao> {
        return this.crudService.insert<GrupoClassificacao>(this.resource, entity);
    }

    /** Altera uma grupo de classificação existente */
    update(entity: GrupoClassificacao): Observable<GrupoClassificacao> {
        return this.crudService.update<GrupoClassificacao>(this.resource, entity);
    }

    /** Exclui uma grupo de classificação através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
